import { FC } from "react";
import { StarRating } from "@components/StarRating/StarRating";
import { Store } from "@types";
import { RatingSource } from "@components/RatingSource/RatingSource";
import styles from "./ReviewInfo.module.css";

interface ReviewInfoProps {
  rating?: number;
  userName: string;
  date: string;
  store?: Store;
  productLink?: string;
}

export const ReviewInfo: FC<ReviewInfoProps> = ({
  rating,
  userName,
  date,
  store,
  productLink,
}) => {
  return (
    <div className={styles.reviewInfo}>
      {rating && (
        <div className={styles.rating}>
          <StarRating rating={rating} variant="medium" />
        </div>
      )}

      <div className={styles.userName}>{userName}</div>

      <div className={styles.date}>{new Date(date).toLocaleDateString()}</div>

      {store && (
        <div className={styles.sourceLink}>
          <RatingSource store={store} productLink={productLink} />
        </div>
      )}
    </div>
  );
};
